export default {"src":"/_next/static/media/customer-pinterest.f7af29de.svg","height":100,"width":100};